<template>
  <div>
    <el-form :inline="true" ref="form" size="mini" label-width="150px">
      <el-form-item :label="$t('dayinmobanmingcheng')" required>
        <el-select v-model="printTemplateId" placeholder="请选择">
          <el-option v-for="printTemplate in printTemplateList" :label="printTemplate.name"
                     :value="printTemplate.id"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item :label="$t('picihao')">
        <el-input disabled v-model="printObj.batchNo"></el-input>
      </el-form-item>
      <el-form-item :label="$t('baozhuangguize')">
        <el-select :multiple="false" :clearable="true" v-model="defaultPackageRuleId" @change="changePackageRule" placeholder="请选择">
          <el-option v-for="packageRule in packageRuleList" :label="packageRule.code+'|'+packageRule.name" :value="packageRule.id"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item :label="$t('baozhuangshuliang')" required>
        <el-input-number @change="packageNumberChange" v-model="printObj.packageNumber" :min="1" step-strictly
                         :max="printObj.planQuantity - (printObj.printedQuantity ? printObj.printedQuantity : 0)"></el-input-number>
      </el-form-item>
      <el-form-item :label="$t('jihuashuliang')">
        <el-input v-model="printObj.planQuantity" disabled></el-input>
      </el-form-item>
      <el-form-item :label="$t('yidayinshuliang')">
        <el-input v-model="printObj.printedQuantity" disabled></el-input>
      </el-form-item>
      <el-form-item :label="$t('shengyudayinshuliang')">
        <el-input v-model="printObj.printableQuantity" disabled></el-input>
      </el-form-item>
      <el-form-item :label="$t('dayinzhangshu')">
        <el-input-number :min="1" :max="maxCount?maxCount:50" step-strictly v-model="printObj.printCount" @change="printCountChange"></el-input-number>
      </el-form-item>
      <el-form-item :label="$t('kehumingcheng')">
        <el-input :value="printObj.plan && printObj.plan.customerName" disabled></el-input>
      </el-form-item>
      <el-form-item :label="$t('baogongriqi')" required>
        <yi_time_input :format="'yyyy-MM-dd'" type="date" :time.sync="printObj.reportDate"> </yi_time_input>
      </el-form-item>
      <el-form-item :label="$t('baogongbanci')" required>
        <el-select filterable v-model="printObj.shiftId" @change="shiftChange">
          <el-option v-for="(item, index) in shiftByEquipment" :key="index" :label="item.name" :value="item.id"> </el-option>
        </el-select>
      </el-form-item>
      <el-form-item :label="$t('dangbanbaogongshuliang')" required>
        <el-input-number disabled :precision="0" :min="0" :step="1" size="mini" v-model="printObj.curShiftQuantity"> </el-input-number>
      </el-form-item>
      <el-form-item :label="$t('feedingQuantity')">
        <el-input v-model="feedingQuantity" disabled></el-input>
      </el-form-item>
      <el-form-item :label="$t('lingliaoqitaoshu')">
        <el-input v-model="erpNum" disabled></el-input>
      </el-form-item>
    </el-form>
    <yi_print_preview v-if="printTemplateId" :printTemplateId.sync="printTemplateId" :scale="4" :printDatas="printDatas" :isPreview="false"
                      ref="yiPrintPreview" @finishPrint="finishPrint" @failedPrint="failedPrint"></yi_print_preview>
    <div style="text-align: center;padding: 20px 0;">
      <el-button :loading="printLoading" @click="$emit('closeDialog')" style="width: 130px;">{{$t('quxiao')}}</el-button>
      <el-button :loading="printLoading" type="primary" @click="print" style="width: 130px;">{{printLoading?$t('dayinzhong'):$t('dayin')}}</el-button>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      printDatas: [],
      printLoading: false,
      printTemplateList: [],
      printTemplateId: null,
      packageRuleList: [],
      defaultPackageRuleId: null,
      printData: {},
      printRecordList: [],
      printObj: null,
      erpNum: 0,
      erpPlanNum: 0,
      feedingQuantity: 0,
      maxCount: 50,
      shiftByEquipment: [], //班次数据
      currentShift:{},
    };
  },
  created() {
    this.$set(this, 'printObj', this.$attrs.printObj);
    this.defaultPackageRuleId = null;
    this.$set(this.printObj, 'printedQuantity', this.$attrs.printObj.finishGoodQuantity);
    this.$set(this.printObj, 'batchNo', this.dayjs().format('YYYYMMDD'));
    this.$set(this.printObj, 'printCount', 1);
    if (!this.printObj.printedQuantity) {
      this.printObj.printedQuantity = 0;
    }
    this.printObj.printableQuantity = this.printObj.planQuantity - (this.printObj.printedQuantity ? this.printObj.printedQuantity : 0);
    //获取包装规则列表
    this.http.get('/web/basic/package_rule/pageByMaterial?pageNum=1&pageSize=99999&orderBy=createTime%20desc&materialId=' + this.$attrs.printObj.materialId).then(res2 => {
      this.packageRuleList = res2.data.rows;
      if (this.packageRuleList.length > 0) {
        this.$set(this, 'defaultPackageRuleId', this.packageRuleList[0].id);
        this.changePackageRule();
      }
    });
    //获取打印模板列表
    this.http.post('/web/print/template/listWeierPrintTemplate', this.$attrs.printObj).then(res => {
      let itemList = res.data;
      this.printTemplateList = itemList;
      if (this.printTemplateList.length > 0) {
        setTimeout(() => {
          this.$set(this, 'printTemplateId', this.printTemplateList[0].id);
          this.$set(this.printObj, 'templateId', this.printTemplateList[0].id);
          this.printDatas = [];
          this.printDatas.push(this.printData);
        }, 800);
      }
    });
    //获取ERP齐套数
    this.http.get('/custom/weier/print/record/getErpNum?woId=' + this.printObj.id).then(res3 => {
      this.erpNum = res3.data;
      if (this.erpNum > 0) {
        this.$set(this, 'erpNum', this.erpNum);
      }
    });
    //获取投料数量
    this.http.get('/custom/weier/print/record/getSumFeedingWeight?woId=' + this.printObj.id).then(res2 => {
      this.$set(this, 'feedingQuantity', res2.data);
    });
    //获取系统管理-生产配置【单次打印标签张数】
    this.http.get('/web/production/config/list?type=15').then(res => {
      if (res.data && res.data.length === 1 && res.data[0].status) {
        this.maxCount = res.data[0].overValue;
      } else {
        this.maxCount = 50;
      }
    }).catch(err => {
      this.$message.error(this.$t(err));
    });
    //获取报工日期
    this.getReportDate();
  },
  methods: {
    print() {
      if (!this.printTemplateId) {
        this.$message.error(this.$t('qingxuanzedayinmoban'));
        return;
      }
      if (!this.printObj.packageNumber) {
        this.$message.error(this.$t('baozhuangshuliang') + this.$t('不能为空'));
        return;
      }
      if(!this.printObj.reportDate){
        this.$message.error(this.$t('baogongriqi') + this.$t('不能为空'));
        return;
      }
      if(!this.printObj.shiftId){
        this.$message.error(this.$t('baogongbanci') + this.$t('不能为空'));
        return;
      }
      if(!this.printObj.curShiftQuantity){
        this.$message.error(this.$t('dangbanbaogongshuliang') + this.$t('不能为空'));
        return;
      }
      this.printObj.businessType = 11;
      this.printObj.woNo = this.printObj.no;
      this.printObj.woId = this.printObj.id;
      this.$set(this.printObj, 'templateId', this.printTemplateId);
      this.printObj.createBy = null;
      this.printObj.createBy = null;
      this.printObj.createTime = null;
      this.printObj.updateBy = null;
      this.printObj.updateTime = null;
      this.printLoading = true;
      //打印丝印工单标签及报工
      this.http.post('/custom/weier/print/record/batchCreateSilkPrintRecordAndReportWork', this.printObj).then(res => {
        this.printDatas = [];
        this.printRecordList = [];
        for (let item of res.data) {
          this.printRecordList.push(item);
          let printDataTemp = item.printData;
          printDataTemp.quantity = item.packageNumber;
          printDataTemp.labelBarcodeNumber = item.labelBarcodeNumber;
          printDataTemp.cartonNumber = item.labelBarcodeNumber;//维尔箱号=条码号
          printDataTemp.cartonQuantity = item.currentOrder;
          this.printDatas.push(printDataTemp);
        }
        setTimeout(() => {
          this.$message.success(this.$t('dayinzhong'));
          this.$refs.yiPrintPreview.print();
        }, 500);
      }).catch(err => {
        this.printLoading = false;
        this.$message.error(err);
      });
    },
    finishPrint() {
      this.$message.success(this.$t('chenggong'));
      this.$emit('closeDialog');
      this.printLoading = false;
    },
    failedPrint(){
      this.printLoading = false;
    },
    changePackageRule() {
      this.http.get('/web/basic/package_rule/page?pageNum=1&pageSize=1&id=' + this.defaultPackageRuleId).then(res => {
        if (res.data.rows.length > 0) {
          let itemList = res.data.rows[0].itemList;
          itemList = itemList.sort((a, b) => {
            return b.sort - a.sort;
          });
          this.printObj.packageNumber = itemList[0].quantity;
          this.printDatas = [];
          this.printDatas.push(this.printData);
        }
      })
    },
    packageNumberChange() {
      this.printData.quantity = this.printObj.packageNumber;
      this.$set(this.printObj,'curShiftQuantity',this.printObj.packageNumber * this.printObj.printCount);
      this.printDatas = [];
      this.printDatas.push(this.printData);
    },
    printCountChange(){
      if(this.printObj.packageNumber != undefined && this.printObj.packageNumber != null){
        this.$set(this.printObj,'curShiftQuantity',this.printObj.packageNumber * this.printObj.printCount);
      }
    },
    getReportDate() {
      this.printLoading = true;
      this.http.get('/web/setting/shift/getCurrentShiftByEquipmentId', {
        params: {
          equipmentId: this.printObj.equipmentId,
          pageNum: 1,
          pageSize: 10
        }
      }).then(res => {
        this.currentShift = res.data;
        this.$set(this.printObj, 'reportDate', Number(res.data.startTime));
        //获取班次
        this.getShiftByEquipmentId();
      });
    },
    getShiftByEquipmentId() {
      this.http.get('/web/setting/shift/getShiftByEquipmentId', {
        params: {
          equipmentId: this.printObj.equipmentId,
          pageNum: 1,
          pageSize: 10
        }
      }).then(res => {
        this.shiftByEquipment = res.data;
        for (let i = 0; i < this.shiftByEquipment.length; i++) {
          if (this.currentShift.id === this.shiftByEquipment[i]['id']) {
            this.$set(this.printObj,'shiftId',this.currentShift.id);
          }
        }
      }).finally(() => {
        this.printLoading = false;
      });
    },
    shiftChange(value) {
      if (Array.isArray(this.shiftByEquipment) && this.shiftByEquipment.length > 0) {
        for (let i = 0; i < this.shiftByEquipment.length; i++) {
          if (value === this.shiftByEquipment[i]['id']) {
            this.printObj.shiftId = value;
          }
        }
      }
    },
  },
}
</script>

<style scoped>

</style>